import cn from "classnames";
import { TableHeadProps } from "./types";
import styles from "./styles.module.scss";

export const TableHead = ({
  children,
  className,
  rowClassName,
  sticky = false,
  dataTestId = "table-head",
  ...restProps
}: TableHeadProps) => (
  <thead
    className={cn(
      cn(styles["table-head"]),
      {
        [styles.sticky]: sticky,
      },
      className
    )}
    data-test-id={dataTestId}
    {...restProps}
  >
    <tr className={cn(styles["table-head-row"], rowClassName)}>{children}</tr>
  </thead>
);
